module.exports = __webpack_public_path__ + "media/images/lb/188-d663150f0b53c6f46637a65487c4efa7.svg";